<template>
  <v-card>
    <v-card-title>
      <span>Abnormal Attendance Approval </span>
      <span>
        <v-btn
          plain
          small
          color="primary"
          class="ml-2"
          @click="refresh()"
        >
          <v-icon>
            mdi-refresh
          </v-icon>
        </v-btn>
      </span>
    </v-card-title>
    <swipe-list
      v-if="abnormalAttendanceList.length>0"
      ref="swipeListRef"
      class="scroll-list mb-2"
      :style="{ maxHeight: nodeHeight }"
      :items="abnormalAttendanceList"
    >
      <template v-slot="{ item, index, revealLeft, revealRight, close }">
        <coach-attendance-item
          :item="item"
          :index="index"
          @click="handleRowClick(item,index)"
        ></coach-attendance-item>
      </template>
      <template v-slot:right="{ item }">
        <div
          class="swipeout-action red"
          @click="handleDelete(item)"
        >
          <v-icon
            large
            color="white"
          >
            mdi-trash-can-outline
          </v-icon>
        </div>
      </template>
    </swipe-list>
    <ApproveAbnormalDialog
      v-model="dialog"
      :record="currentRecord"
      @close="handleCloseDialog"
    ></ApproveAbnormalDialog>
    <v-card
      v-if="abnormalAttendanceList.length==0"
      class="card-content"
    >
      <v-list-item>
        <v-list-item-content>
          list is empty ( filtered or just empty )
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </v-card>
</template>
<script setup>
import { ref, onMounted, computed, toRefs, watch, onBeforeUnmount } from 'vue'
import { getVuetify } from '@core/utils'
import { listAbnormal } from '@/api/coachAttendance'
import { formatTime, formatDate, hasRole, loading } from '@/utils/helper'
import SwipeList from '@/components/SwipeList/SwipeList.vue'
import CoachAttendanceItem from '@/views/pages/components/AttendanceManagement/CoachAttendanceItem.vue'

import ApproveAbnormalDialog from '@/views/pages/components/AttendanceManagement/ApproveAbnormalDialog.vue'

const dialog = ref(false)
const swipeListRef = ref(null)

const abnormalAttendanceList = ref([])

const nodeHeight = ref('0px')
const $vuetify = getVuetify()
const isMobile = computed(() => $vuetify.breakpoint.mdAndDown)
function updateNodeHeight() {
  let extraHeight = 0
  extraHeight = 0
  if (isMobile) {
    extraHeight = 125
  }
  const nodeHeightValue = window.innerHeight - 180 - 40 - extraHeight
  console.log('nodeHeightValue', nodeHeightValue)
  nodeHeight.value = `${nodeHeightValue}px`
}
onBeforeUnmount(() => {
  window.removeEventListener('resize', updateNodeHeight)
})

function fetchAbnormal() {
  console.log('fetchAbnormal')

  return new Promise(resolve => {
    const postData = {
      page: 0,
      limit: 0,
      orderBy: 'CheckinDateTime',
    }
    listAbnormal(postData).then(result => {
      console.log('result')
      if (result.data) {
        console.log('fetchAbnormal', result.data.items)
        const { items } = result.data
        abnormalAttendanceList.value = items
        resolve(items)
      }
    }).finally(() => {
      loading(false)
    })
  })
}
function refresh() {
  loading(true)
  fetchAbnormal()
}
onMounted(() => {
  updateNodeHeight()
  window.addEventListener('resize', updateNodeHeight)

  refresh()
})

const defaultRecordPlacement = {
  id: -1,
  userRecordID: -1, // 30040,
  centerID: -1,
  center: {
    description: '',
  },
  attendanceDate: '0001-01-01T00:00:00.000Z',
  checkinDateTime: '0001-01-01T00:00:00.0007Z',
  checkoutDateTime: '0001-01-01T00:00:00.0007Z',
  calculated: false,
  userRecord: {
    id: 30040,
    firstName: 'First Name', // Jason
    lastName: 'Last Name', // LI
    username: 'A230300001',
    userNo: 'A230300001',
    mobileNo: '12345678',
    fullName: 'First Name Last Name',
    avatar: 'User/Avatar/30040',
  },
  coachAttendanceAbnormal: {
    reason: '',
    checkoutDateTime: '0001-01-01T00:00:00.0007Z',
    abnormalApprovalStatusID: -1,
  },
}
const currentRecord = ref({ ...defaultRecordPlacement })
function handleCloseDialog() {
  currentRecord.value = { ...defaultRecordPlacement }

  dialog.value = false

  if (swipeListRef.value) {
    swipeListRef.value.close()
  }

  refresh()
}

function handleRowClick(item, index) {
  console.log('handleRowClick', item, index)
  currentRecord.value = item
  dialog.value = true
}

</script>
<style scoped>

</style>
